/**
 * Created by adalto on 4/7/14.
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};

Greenmile.Toolbar.ConfigInfoMarkerTruckActions = function () {

    var infoStore = {};
    var KEY_LOCAL_STORAGE = 'infoMarkerTruck';
    var gmLocalStorage = new Greenmile.Storage.StoreMapPosition();

    var init = function () {

        var data = Monet.Session.sessionStorage.getItem(KEY_LOCAL_STORAGE);

        if (data && data !== '""') {

            infoStore = JSON.parse(data);

        }

    };

    this.saveOnLocalStorage = function (organizationId, value) {

        init();

        infoStore[organizationId] = value;

        Monet.Session.sessionStorage.setItem(KEY_LOCAL_STORAGE, JSON.stringify(infoStore));

        gmLocalStorage.storageIsChanged();


    };

    this.getInfoMarkerSelectedByOrganizationId = function (organizationId) {

        var infoDefault = Greenmile.ConfigInfoMarkerTruck.Utils.options.EQUIPMENT.value;

        return infoStore[organizationId] || infoDefault;

    };

    init();


};